<template>
    <div class="homePage" >
        <div class="homeLeft" :class="{'homeLeftCollapse': isCollapse}">
            <div class="homeLeftTop">
                <img src="@/assets/img/logo.png" alt="">
            </div>
            <el-menu :collapse="isCollapse" :default-active="activeIndex" class="menu_nav" @select="handleSelect">
                <el-menu-item class="menu-group-item" index="question">
					<i class="iconfont icon-tiaochawenjuan_fuzhi"></i>
        			<span slot="title">调查问卷</span>
				</el-menu-item>
				<el-menu-item class="menu-group-item" index="signList">
					<i class="iconfont icon-baomingbiao"></i>
        			<span slot="title">报名表单</span>
				</el-menu-item>
				<el-menu-item class="menu-group-item" index="recruitManage">
					<i class="iconfont icon-zhaopingangwei"></i>
        			<span slot="title">招聘岗位</span>
				</el-menu-item>
				<el-menu-item class="menu-group-item" disabled @click.native="toMicroWeb" index="microWeb">
					<i class="iconfont icon-weiguanwang"></i>
        			<span slot="title">微官网</span>
				</el-menu-item>
            </el-menu>
        </div>
        <div class="homeRight">
            <router-view class="homeRightPage"></router-view>
        </div>
    </div>
</template>

<script>
export default {
    name: 'home',
    data() {
        return {
            isCollapse: false,
        }
    },
    computed: {
        activeIndex() {
            return this.$route.meta.parent || this.$route.name;
        }
    },
    mounted() {
        this.resizeEvent();
    },
    methods: {
		toMicroWeb() {
			window.open('https://v.inmugo.com/admin/#/', '_blank');
		},
        handleSelect(index) {
            this.$router.push({name: index});
        },
        resizeEvent() {
			this.resizeMenu();
			window.onresize = this.resizeMenu;
		},
        // 重绘菜单
		resizeMenu() {
			const w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			// this.isCollapse = w <= 1490;
		},
    }
}
</script>

<style lang="less">
.homePage {
    height: 100vh;
    display: flex;
    overflow: hidden;
    .homeLeft {
        width: 230px;
        height: 100%;
        &.homeLeftCollapse {
            width: 78px;
        }
    }
    .el-menu {
        border: none;
    }
    .homeLeftTop {
        height: 68px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid #dcdfe6;
        img {
            width: 100%;
			height: 100%;
        }
    }

    .homeRight {
        flex: 1;
        height: 100%;
        overflow: hidden;
        .homeRightPage {
            height: 100%;
            display: flex;
            flex-direction: column;
            .homeRightContent {
				height: 100%;
                box-sizing: border-box;
                padding: 24px;
                flex: 1;
                overflow: hidden;
				display: flex;
				flex-direction: column;
				.tableContainer {
					flex: 1;
					overflow: hidden;
				}
            }
        }
    }
}
// 下方使用了大量的important， 因为组件默认的样式要么是直接行内样式，要么就是加了important，没办法，只能这么写
// 使用important仅存于当前类名，不会造成后续的样式污染，不过修改这里的时候，请注意important相关样式修改是否生效
.menu_nav {
	//ie滚动条
	-ms-scroll-chaining: chained;
	-ms-content-zooming: zoom;
	-ms-scroll-rails: none;
	-ms-content-zoom-limit-min: 100%;
	-ms-content-zoom-limit-max: 500%;
	-ms-scroll-snap-type: proximity;
	-ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
	-ms-overflow-style: none;
	width: 230px;
	height: 100%;
	flex-shrink: 0;
	overflow-y: auto;
	overflow-x: hidden;
	box-sizing: border-box;
	padding: 24px 8px;
	display: flex;
	flex-flow: column nowrap;
	z-index: 11;
	border-right: 1px solid #EEEEEE !important;
	&::-webkit-scrollbar {
		display: none;
	}
	.el-menu-item {
		height: auto;
		padding: 9px 12px;
		line-height: 22px;
		border-radius: 4px;
		& + .el-menu-item {
			margin-top: 8px;
		}
		&.is-disabled {
			cursor: pointer;
			opacity: 1;
			background: none;
			&:hover, &:focus {
				background: rgba(22, 93, 255, 0.05) !important;
			}
		}
		&:hover, &:focus {
			background: rgba(22, 93, 255, 0.05);
		}
		&.is-active {
			background: rgba(22, 93, 255, 0.05);
			&::after {
				content: '';
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
				left: 0;
				width: 2px;
				height: 16px;
				background: rgba(22, 93, 255, 1);
				border-radius: 0 2px 2px 0;
			}
			.iconfont {
				color: rgba(22, 93, 255, 1);
			}
			span {
				color: rgba(22, 93, 255, 1);
			}
		}
		.iconfont {
			font-size: 18px;
			margin-right: 8px;
			color: rgba(201, 204, 209, 1);
		}
		span {
			font-size: 14px;
			line-height: 22px;
			color: rgba(29, 33, 41, 1);
		}
	}
}
</style>
